export const weekDaysEnum = {
	'Lundi': 'Lundi',
	'Mardi': 'Mardi',
	'Mercredi': 'Mercredi',
	'Jeudi': 'Jeudi',
	'Vendredi': 'Vendredi'
}

export const timeSlotEnum = {
	'Matin': 'Matin',
	'Après-midi': 'Après-midi'
}
